import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import {
  createCredentialsCallbacks,
  credentialsPollerGlobal,
} from '../../../connectivity/services/credentials';

export const useCredentialsPoller = () => {
  const dispatch = useDispatch();

  const signCredentials = useCallback(
    (credentialsId: string, credentialsPoller = credentialsPollerGlobal) => {
      const credentialCallbacks = createCredentialsCallbacks({ dispatch });

      credentialsPoller.run(credentialCallbacks, credentialsId);
    },
    [dispatch]
  );

  return { signCredentials };
};
